@if (filterForm) {
    <mat-drawer-container [hasBackdrop]="true">
        <mat-drawer #sidenav [mode]="'over'">
            <app-risk-insights-filter-sidebar
                [filterForm]="filterForm"
                (closeButtonClicked)="sidenav.close()"
                [timeFrameList]="timeFrameList"
                [userList]="userList$ | async"
                [showGroupFilters]="groupsEnabled"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-risk-insights-filter-sidebar>
        </mat-drawer>
        <mat-drawer-content class="app-content listings">
            <app-risk-insights-filter-topbar
                [filterForm]="filterForm"
                [currentFilters]="currentFilters"
                (filterButtonClicked)="sidenav.open()"
                [userList]="userList$ | async"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-risk-insights-filter-topbar>

            <div class="app-content px-0">
                @if (stats$ | async; as stats) {
                    @if (stats.meta.results) {
                        <app-risk-type-stats
                            [data]="stats.data"></app-risk-type-stats>
                    } @else {
                        <app-empty-state
                            illustration="search"
                            title="No Statistics Yet"
                            message="There is no data in the selected date range and filters.">
                            <a
                                class="btn-secondary"
                                (click)="sidenav.open(); $event.stopPropagation()">
                                Edit Filters
                            </a>
                        </app-empty-state>
                    }
                } @else {
                    <app-loading-indicator></app-loading-indicator>
                }
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
}
